import { Outlet } from 'react-router-dom';

import { DrawerManager } from '@/components/Drawer/components/DrawerManager';
import { AdminAside } from '@/components/layout/aside/AdminAside';
import { ContainerSetter } from '@/components/layout/topbar/ContainerSetter';
import { Topbar } from '@/components/layout/topbar/Topbar';
import { useAppSelector } from '@/store';
import { cn } from '@/utils/cn';
import '@/components/layout/authenticatedShell.scss';

export function AuthenticatedShell() {
  const sidebarOpen = useAppSelector((state) => state.ui.sidebarOpen);

  return (
    <div className={
      cn(
        'app-shell', 
          sidebarOpen 
            ? 'app-shell--sidebar-open' 
            : 'app-shell--sidebar-closed'
      )
    }>
      <AdminAside />
      <div className="app-shell__main">
        <Topbar />
        <ContainerSetter>
          <Outlet />
        </ContainerSetter>
      </div>
      <DrawerManager />
    </div>
  );
}
